import { Pipe, PipeTransform } from '@angular/core';
import { SesionService } from '../services/sesion.service';
import { WebServicesService } from '../services/web-services.service';

@Pipe({
  name: 'loadCities',
  standalone: true
})
export class LoadCitiesPipe implements PipeTransform {

  constructor(
    private sesionService: SesionService,
    private webService: WebServicesService
  ) {}

  transform(cities: any[], idCity: string): any[] {
    if (cities && cities.length == 0) { return [] }

    if (!idCity) {
      const citiesSaved = JSON.parse(this.sesionService.getDestinationCitiesPipe(this.webService.newComplemt));
      if (!citiesSaved) { return [] }
      
      return citiesSaved;
    }
    
    const destinationCities = cities.filter((city) => city.id === idCity)[0]?.destinos;

    if (!destinationCities) { return [] }

    this.sesionService.saveDestinationCitiesPipe(this.webService.newComplemt, destinationCities)
    
    return destinationCities;
  }

}
